import React from "react";
import {
	// SEO,
	PageBanner,
	BigHeading,
	Tickertape,
	ArtistBanner,
} from "../components";
import { tw } from "../tw";
import { Helmet } from "react-helmet";
import BlockContent from "@sanity/block-content-to-react";

/* Artist Template
============================================================================= */

const ArtistTemplate = ({ pageContext }) => {
	// Config
	const { title, artist } = pageContext;

	// Render
	return (
		<>
			<Helmet>
				<title>{title}</title>
			</Helmet>
			<PageBanner />
			<Tickertape />
			<BigHeading text={title} />
			<div className={tw.blockContentContainer}>
				<ArtistBanner
					image={artist.image.asset.gatsbyImageData}
					spotify={artist.spotify}
					artist={artist}
				/>
				<BlockContent
					blocks={artist._rawAbout}
					className="block-content prose-xl pt-8 px-4"
					renderContainerOnSingleChild
				/>
			</div>
		</>
	);
};

/* Export
============================================================================= */

export default ArtistTemplate;
